export const AUTH_ENDPOINTS = {
    LOGIN: "/login",
    LOGOUT: "/logout",
    ME: "/me",
    REGISTER: "/register",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    // Changement de mot de passe d'un utilisateur DEJA connecte. tc_identity
    // verifie que le userapp_id vise est bien celui de l'appelant.
    REPLACE_PASSWORD: "/passwords/replace",
    RESEND_CONFIRMATION: "/resend-confirmation-email",
} as const;
